<template>
  <div>
    <el-form label-width="100px">
      <el-checkbox-group v-model="subDate" size="small">
        <el-checkbox v-for="item in permissionList" :key="item.value" :label="item.value" border :checked="item.check">{{item.label}}</el-checkbox>
      </el-checkbox-group>
      <el-form-item style="margin-top: 10px;">
        <el-button type="primary" @click="onSubmit" plain>提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { mixin, propValue } from '@/mixins/index'

export default {
  mixins: [mixin(), propValue()],
  computed: {
    ...mapState([
      'userInfo'
    ])
  },
  data () {
    return {
      subDate: [],
      formItem: {
        user_id: 0
      },
      data: [],
      permissionList: []
    }
  },
  methods: {
    onSubmit () {
      this.$msgbox({
        title: this.$t('normal.tip'),
        message: '确定吗？',
        confirmButtonText: this.$t('button.confirm'),
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = this.$t('normal.process')
            instance.title = this.$t('normal.processTitle')
            instance.message = this.$t('normal.processMessage')
            setTimeout(() => {
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 300)
            }, 1000)
          } else {
            done()
          }
        }
      }).then(action => {
        if (action === 'confirm') {
          const subDate = {}
          for (let i = 0; i < this.subDate.length; i++) {
            subDate[i] = this.subDate[i]
          }
          this.postFetch('/api/user_permission/edit', { permissionList: subDate, user_id: this.formItem.user_id }, { needSuccess: true }).then((response) => {
            // this.$router.replace({ path: '/course/index' })
          })
        }
      })
    }
  },
  created () {
    this.permissionList = this.$route.matched[0].props.default.permissionList
    this.formItem.user_id = this.$route.query.id
    this.getFetch('/api/user_permission/index', this.formItem).then(response => {
      for (let i = 0; i < response.length; i++) {
        this.subDate.push(response[i].u_permission)
      }
    })
  }
}
</script>
